import "intersection-observer";
import $ from "jquery";
import "jquery-match-height";
import "magnific-popup";
import "slick-carousel";
import SweetScroll from "sweet-scroll";
import lazySizes from "lazysizes";

if (typeof window !== "undefined") {
  window.$ = $;
  window.jQuery = $;
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    lazySizes.init();
    document.addEventListener("lazybeforeunveil", function (e) {
      var bg = e.target.getAttribute("data-bg");
      if (bg) {
        e.target.style.backgroundImage = "url(" + bg + ")";
      }
    });

    new SweetScroll({ offset: 0 });

    const $mv = document.querySelector(".sauna-mv");
    const $form = document.querySelector("#form");
    const $fixed = document.querySelector(".sauna-fixed");
    const $menu = document.querySelector(".sauna-menu");
    const $menuToggle = document.querySelector(".sauna-menu__toggle");
    const $menuPanel = document.querySelector(".sauna-menu__panel");
    const $menuLabel = $menuToggle && $menuToggle.querySelector(".sauna-menu__toggle-label");
    const $pagetop = document.querySelector(".sauna-pagetop");
    let menuScrollY = 0;
    const setMenuOpen = (open) => {
      if (!$menu || !$menuToggle || !$menuPanel) return;
      const html = document.documentElement;
      const body = document.body;
      if (open) {
        menuScrollY = window.scrollY || html.scrollTop || 0;
        body.style.top = `-${menuScrollY}px`;
      }
      $menu.classList.toggle("is-open", open);
      html.classList.toggle("sauna-menu-open", open);
      body.classList.toggle("sauna-menu-open", open);
      if (!open) {
        body.style.top = "";
        window.scrollTo(0, menuScrollY);
      }
      $menuPanel.setAttribute("aria-hidden", open ? "false" : "true");
      $menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
      $menuToggle.setAttribute("aria-label", open ? "メニューを閉じる" : "メニューを開く");
      if ($menuLabel) $menuLabel.textContent = open ? "CLOSE" : "MENU";
      if ($fixed) $fixed.classList.toggle("is-forced", open);
    };
    if ($menuToggle) {
      $menuToggle.addEventListener("click", () => {
        setMenuOpen(!$menu.classList.contains("is-open"));
      });
    }
    if ($menuPanel) {
      $menuPanel.addEventListener("click", (event) => {
        const link = event.target.closest("a");
        if (link) setMenuOpen(false);
      });
    }
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && $menu && $menu.classList.contains("is-open")) {
        setMenuOpen(false);
        if ($menuToggle) $menuToggle.focus();
      }
    });
    if ($mv && ($fixed || $pagetop)) {
      const inView = (el) => {
        if (!el) return false;
        const r = el.getBoundingClientRect();
        return r.bottom > 0 && r.top < window.innerHeight;
      };
      const syncFixed = () => {
        const hide = inView($mv) || inView($form);
        if ($fixed) $fixed.classList.toggle("is-hidden", hide);
        if ($pagetop) $pagetop.classList.toggle("is-hidden", hide);
      };
      window.addEventListener("scroll", syncFixed, { passive: true });
      window.addEventListener("resize", syncFixed);
      syncFixed();
    }

    $("[data-scroll]").each(function () {
      const href = $(this).attr("href");
      if (href && !href.startsWith("#")) {
        const split = href.split("#");
        if (split[0] === location.pathname) {
          $(this).attr("href", "#" + split[1]);
        } else {
          $(this).removeAttr("data-scroll");
        }
      }
    });

    const $flowSlide = $(".sauna-flow__slide");
    if ($flowSlide.length) {
      $flowSlide.slick({
        autoplay: true,
        autoplaySpeed: 0,
        speed: 10000,
        cssEase: "linear",
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        swipe: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        variableWidth: true,
        rows: 0,
      });
    }

    $(".sauna-flow__head, .sauna-faq__q").on("click", function () {
      $(this).toggleClass("is-open").next().slideToggle();
    });

    const $dummyForm = $(".sauna-form__form, .sauna-form .wpcf7-form").first();
    if ($dummyForm.length) {
      const $agree = $dummyForm.find('[name="your-agree"]');
      const $submit = $dummyForm.find(".sauna-form__submit, input.wpcf7-submit");
      const syncSubmit = () => {
        $submit.prop("disabled", !$agree.is(":checked"));
      };
      syncSubmit();
      $agree.on("change", syncSubmit);

      const $year = $dummyForm.find('[name="your-year"]');
      const $month = $dummyForm.find('[name="your-month"]');
      const $day = $dummyForm.find('[name="your-day"]');
      const $nativeDate = $dummyForm.find(".sauna-form__date-native");
      const $dateError = $dummyForm.find(".sauna-form__date-error");
      const nativeDate = $nativeDate.get(0);
      const today = new Date();
      const todayY = today.getFullYear();
      const todayM = today.getMonth() + 1;
      const todayD = today.getDate();

      const daysInMonth = (year, month) => new Date(year, month, 0).getDate();
      const nthWeekday = (year, month, weekday, n) => {
        const firstWeekday = new Date(year, month - 1, 1).getDay();
        const day = 1 + ((weekday - firstWeekday + 7) % 7) + (n - 1) * 7;
        return day <= daysInMonth(year, month) ? day : null;
      };
      const isClosedThursday = (year, month, day) => {
        if (!year || !month || !day) return false;
        return (
          day === nthWeekday(year, month, 4, 2) ||
          day === nthWeekday(year, month, 4, 4)
        );
      };
      const isPastDate = (year, month, day) => {
        if (!year || !month || !day) return false;
        return (
          year * 10000 + month * 100 + day <
          todayY * 10000 + todayM * 100 + todayD
        );
      };
      const pad2 = (n) => String(n).padStart(2, "0");
      const todayValue = todayY + "-" + pad2(todayM) + "-" + pad2(todayD);
      const applyNativeLimit = () => {
        if (!nativeDate) return;
        nativeDate.min = todayValue;
        nativeDate.max = todayY + 1 + "-12-31";
      };
      applyNativeLimit();

      const showDateError = (message) => {
        $dateError.text(message).prop("hidden", false);
      };
      const hideDateError = () => {
        $dateError.prop("hidden", true);
      };
      const resetSelect = ($select) => {
        $select.prop("selectedIndex", 0);
      };
      const clearDayAndNative = () => {
        resetSelect($day);
        if (nativeDate) nativeDate.value = "";
        syncDateSelectUi($day);
      };
      const monthIsSelected = () => {
        const month = Number($month.val());
        return month >= 1 && month <= 12;
      };
      const closeDateSelectMenus = (except) => {
        $dummyForm.find(".sauna-form__select-ui.is-open").each(function () {
          if (except && this === except) return;
          $(this).removeClass("is-open");
          $(this).find(".sauna-form__select-btn").attr("aria-expanded", "false");
          $(this).find(".sauna-form__select-list").prop("hidden", true);
        });
      };
      const openDateSelectMenu = ($select) => {
        const $ui = $select.siblings(".sauna-form__select-ui");
        if (!$ui.length) return;
        closeDatepicker();
        closeDateSelectMenus($ui.get(0));
        $ui.addClass("is-open");
        $ui.find(".sauna-form__select-btn").attr("aria-expanded", "true");
        $ui.find(".sauna-form__select-list").prop("hidden", false);
      };
      const syncDateSelectUi = ($select) => {
        const api = $select.data("saunaSelectUi");
        if (api && typeof api.sync === "function") api.sync();
      };
      const enhanceDateSelect = ($select) => {
        if (!$select.length || $select.data("saunaSelectUi")) return;
        let $wrap = $select.closest(".wpcf7-form-control-wrap");
        if (!$wrap.length) {
          $select.wrap('<span class="wpcf7-form-control-wrap has-select-ui"></span>');
          $wrap = $select.parent();
        } else {
          $wrap.addClass("has-select-ui");
        }
        const $ui = $('<div class="sauna-form__select-ui"></div>');
        const $btn = $(
          '<button type="button" class="sauna-form__select-btn" aria-haspopup="listbox" aria-expanded="false"><span class="sauna-form__select-btn-text"></span></button>'
        );
        const $btnText = $btn.find(".sauna-form__select-btn-text");
        const $list = $('<ul class="sauna-form__select-list" hidden role="listbox"></ul>');
        $ui.append($btn, $list);
        $select.after($ui);
        const isPlaceholderOption = ($opt) => {
          const text = $.trim($opt.text());
          return $opt.index() === 0 && (text === "月" || text === "日");
        };
        const syncUi = () => {
          const $selected = $select.find("option:selected");
          $btnText.text($.trim($selected.text()) || "");
          if ($select.is($day)) {
            const ready = monthIsSelected();
            $btn.toggleClass("is-disabled", !ready);
            $btn.attr("aria-disabled", ready ? "false" : "true");
          }
          $list.empty();
          $select.find("option").each(function () {
            const $opt = $(this);
            if (isPlaceholderOption($opt)) return;
            const selected = $opt.is(":selected");
            const $itemBtn = $("<button>", {
              type: "button",
              role: "option",
              text: $.trim($opt.text()),
              "data-value": $opt.attr("value"),
              "aria-selected": selected ? "true" : "false",
            });
            if (selected) $itemBtn.addClass("is-selected");
            $list.append($("<li></li>").append($itemBtn));
          });
        };
        $btn.on("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          closeDatepicker();
          if ($select.is($day) && !monthIsSelected()) {
            showDateError("先に月を選択してください。");
            openDateSelectMenu($month);
            return;
          }
          const willOpen = !$ui.hasClass("is-open");
          closeDateSelectMenus(willOpen ? $ui.get(0) : null);
          if (!willOpen) return;
          $ui.addClass("is-open");
          $btn.attr("aria-expanded", "true");
          $list.prop("hidden", false);
        });
        $list.on("click", "button", function (e) {
          e.preventDefault();
          e.stopPropagation();
          $select.val($(this).attr("data-value")).trigger("change");
          closeDateSelectMenus();
        });
        $select.on("change.saunaSelectUi", syncUi);
        $select.data("saunaSelectUi", { sync: syncUi });
        syncUi();
      };
      const rebuildSelect = ($select, values, selected) => {
        const placeholder = $select.find("option").first().clone();
        $select.empty().append(placeholder);
        values.forEach((value) => {
          $select.append($("<option>", { value: value, text: value }));
        });
        let kept = false;
        if (selected && values.indexOf(Number(selected)) !== -1) {
          $select.val(String(selected));
          kept = true;
        } else {
          $select.prop("selectedIndex", 0);
        }
        syncDateSelectUi($select);
        return kept;
      };
      const refreshMonthSelect = () => {
        const year = Number($year.val());
        const selected = $month.val();
        const months = [];
        for (let month = 1; month <= 12; month++) {
          if (year === todayY && month < todayM) continue;
          months.push(month);
        }
        const kept = rebuildSelect($month, months, selected);
        if (!kept) clearDayAndNative();
      };
      const refreshDaySelect = () => {
        const year = Number($year.val());
        const month = Number($month.val());
        const selected = $day.val();
        const days = [];
        if (year && month) {
          const max = daysInMonth(year, month);
          for (let day = 1; day <= max; day++) {
            if (isClosedThursday(year, month, day) || isPastDate(year, month, day)) {
              continue;
            }
            days.push(day);
          }
        }
        const kept = rebuildSelect($day, days, selected);
        if (!kept && nativeDate) nativeDate.value = "";
      };
      const applyDate = (year, month, day) => {
        $year.val(String(year));
        refreshMonthSelect();
        $month.val(String(month));
        refreshDaySelect();
        $day.val(String(day));
        syncDateSelectUi($year);
        syncDateSelectUi($month);
        syncDateSelectUi($day);
        if (nativeDate) {
          nativeDate.value = year + "-" + pad2(month) + "-" + pad2(day);
        }
        $year.add($month).add($day).each(function () {
          this.dispatchEvent(new Event("input", { bubbles: true }));
        });
      };
      const rejectNativeIfInvalid = () => {
        const value = $nativeDate.val();
        if (!value) return false;
        if (value < todayValue) {
          if (nativeDate) nativeDate.value = "";
          resetSelect($day);
          showDateError("本日より前の日付は選択できません。");
          return true;
        }
        const parts = value.split("-");
        const year = Number(parts[0]);
        const month = Number(parts[1]);
        const day = Number(parts[2]);
        if (isClosedThursday(year, month, day)) {
          if (nativeDate) nativeDate.value = "";
          resetSelect($day);
          showDateError("第2・第4木曜日は定休日です。別の日付を選択してください。");
          return true;
        }
        return false;
      };

      const $calendar = $dummyForm.find(".sauna-form__calendar");
      const $datepicker = $(
        '<div class="sauna-form__datepicker" hidden role="dialog" aria-label="日付を選択"></div>'
      );
      $calendar.append($datepicker);
      let pickerY = todayY;
      let pickerM = todayM;
      const weekdayLabels = ["日", "月", "火", "水", "木", "金", "土"];
      const closeDatepicker = () => {
        $datepicker.prop("hidden", true);
      };
      const renderDatepicker = () => {
        const firstWeekday = new Date(pickerY, pickerM - 1, 1).getDay();
        const max = daysInMonth(pickerY, pickerM);
        const canPrev = pickerY > todayY || (pickerY === todayY && pickerM > todayM);
        const canNext = pickerY < todayY + 1 || (pickerY === todayY + 1 && pickerM < 12);
        let html =
          '<div class="sauna-form__datepicker-nav">' +
          '<button type="button" class="sauna-form__datepicker-nav-btn" data-picker-prev aria-label="前の月"' +
          (canPrev ? "" : " disabled") +
          ">‹</button>" +
          '<p class="sauna-form__datepicker-caption">' +
          pickerY +
          "年" +
          pickerM +
          "月</p>" +
          '<button type="button" class="sauna-form__datepicker-nav-btn" data-picker-next aria-label="次の月"' +
          (canNext ? "" : " disabled") +
          ">›</button>" +
          "</div>" +
          '<div class="sauna-form__datepicker-week">';
        weekdayLabels.forEach((label) => {
          html += "<span>" + label + "</span>";
        });
        html += '</div><div class="sauna-form__datepicker-days">';
        for (let i = 0; i < firstWeekday; i++) {
          html += "<span></span>";
        }
        const selectedY = Number($year.val());
        const selectedM = Number($month.val());
        const selectedD = Number($day.val());
        for (let day = 1; day <= max; day++) {
          const disabled =
            isClosedThursday(pickerY, pickerM, day) || isPastDate(pickerY, pickerM, day);
          const selected =
            selectedY === pickerY && selectedM === pickerM && selectedD === day;
          html +=
            '<button type="button" class="sauna-form__datepicker-day' +
            (selected ? " is-selected" : "") +
            '" data-day="' +
            day +
            '"' +
            (disabled ? " disabled" : "") +
            ">" +
            day +
            "</button>";
        }
        html += "</div>";
        $datepicker.html(html);
      };
      const openDatepicker = () => {
        pickerY = Number($year.val()) || todayY;
        pickerM = Number($month.val()) || todayM;
        if (pickerY < todayY || (pickerY === todayY && pickerM < todayM)) {
          pickerY = todayY;
          pickerM = todayM;
        }
        renderDatepicker();
        $datepicker.prop("hidden", false);
      };

      $dummyForm.find(".sauna-form__calendar-btn").on("click", function (e) {
        e.stopPropagation();
        closeDateSelectMenus();
        if ($datepicker.prop("hidden")) {
          openDatepicker();
        } else {
          closeDatepicker();
        }
      });
      $datepicker.on("click", function (e) {
        e.stopPropagation();
      });
      $datepicker.on("click", "[data-picker-prev]", function () {
        if (this.disabled) return;
        if (pickerM === 1) {
          pickerY -= 1;
          pickerM = 12;
        } else {
          pickerM -= 1;
        }
        renderDatepicker();
      });
      $datepicker.on("click", "[data-picker-next]", function () {
        if (this.disabled) return;
        if (pickerM === 12) {
          pickerY += 1;
          pickerM = 1;
        } else {
          pickerM += 1;
        }
        renderDatepicker();
      });
      $datepicker.on("click", ".sauna-form__datepicker-day:not(:disabled)", function () {
        hideDateError();
        applyDate(pickerY, pickerM, Number(this.getAttribute("data-day")));
        closeDatepicker();
      });
      $(document).off("mousedown.saunaDatepicker").on("mousedown.saunaDatepicker", function (e) {
        const $t = $(e.target);
        if (!$t.closest(".sauna-form__calendar").length) {
          closeDatepicker();
        }
        if (!$t.closest(".sauna-form__select-ui").length) {
          closeDateSelectMenus();
        }
      });

      $year.on("change", function () {
        hideDateError();
        refreshMonthSelect();
        refreshDaySelect();
      });
      $month.on("change", function () {
        hideDateError();
        refreshDaySelect();
      });

      $day.on("change", function () {
        const year = Number($year.val());
        const month = Number($month.val());
        const day = Number($day.val());
        if (!year || !month || !day) return;
        if (isPastDate(year, month, day)) {
          clearDayAndNative();
          showDateError("本日より前の日付は選択できません。");
          return;
        }
        if (isClosedThursday(year, month, day)) {
          clearDayAndNative();
          showDateError("第2・第4木曜日は定休日です。別の日付を選択してください。");
          return;
        }
        hideDateError();
        if (nativeDate) {
          nativeDate.value = year + "-" + pad2(month) + "-" + pad2(day);
        }
      });

      $nativeDate.on("keydown", function (e) {
        if (e.key !== "Tab") e.preventDefault();
      });
      $nativeDate.on("input change", function () {
        applyNativeLimit();
        if (rejectNativeIfInvalid()) return;
        const value = this.value;
        if (!value) return;
        const parts = value.split("-");
        hideDateError();
        applyDate(Number(parts[0]), Number(parts[1]), Number(parts[2]));
      });

      if (!$year.val()) {
        $year.val(String(todayY));
      }
      enhanceDateSelect($year);
      enhanceDateSelect($month);
      enhanceDateSelect($day);
      refreshMonthSelect();
      refreshDaySelect();

      $dummyForm.on("submit", function (e) {
        if (!$dummyForm.closest(".wpcf7").length && !$dummyForm.hasClass("wpcf7-form")) {
          e.preventDefault();
        }
      });
    }
  },
  false
);

const clearSaunaCf7FieldError = (form, wrap) => {
  if (!(form instanceof Element) || !(wrap instanceof Element)) return;
  const name = wrap.getAttribute("data-name");
  if (!name) return;

  const unitTag = form.wpcf7 && form.wpcf7.unitTag;
  if (unitTag && form.wpcf7.parent) {
    const tipId = (unitTag + "-ve-" + name).replace(/[^0-9a-z_-]+/gi, "");
    const srItem = form.wpcf7.parent.querySelector(".screen-reader-response ul li#" + tipId);
    if (srItem) srItem.remove();
  }

  form.querySelectorAll('.wpcf7-form-control-wrap[data-name="' + name + '"]').forEach((el) => {
    const tip = el.querySelector(".wpcf7-not-valid-tip");
    if (tip) tip.remove();
    el.querySelectorAll("[aria-invalid]").forEach((ctrl) => {
      ctrl.setAttribute("aria-invalid", "false");
    });
    el.querySelectorAll(".wpcf7-form-control").forEach((ctrl) => {
      ctrl.classList.remove("wpcf7-not-valid");
      ctrl.removeAttribute("aria-describedby");
      if (typeof ctrl.setCustomValidity === "function") ctrl.setCustomValidity("");
    });
  });
};

const clearSaunaCf7FieldErrorOnEdit = (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const form = target.closest(".sauna-form .wpcf7-form");
  if (!form) return;
  const wrap = target.closest(".wpcf7-form-control-wrap[data-name]");
  if (!wrap || !wrap.querySelector(".wpcf7-not-valid, .wpcf7-not-valid-tip")) return;
  clearSaunaCf7FieldError(form, wrap);
};

document.addEventListener("input", clearSaunaCf7FieldErrorOnEdit, true);
document.addEventListener("change", clearSaunaCf7FieldErrorOnEdit, true);

document.addEventListener("wpcf7invalid", (event) => {
  const form = event.target;
  if (!(form instanceof Element) || !form.closest(".sauna-form")) return;

  const scrollToFormError = () => {
    const control = form.querySelector(".wpcf7-not-valid");
    const tip = form.querySelector(".wpcf7-not-valid-tip");
    const el = control || tip || form.querySelector(".sauna-form__date-error:not([hidden])");
    if (!el) return false;
    const target = el.closest(".sauna-form__item") || el;
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    if (control && typeof control.focus === "function") {
      try {
        control.focus({ preventScroll: true });
      } catch (err) {
        control.focus();
      }
    }
    return true;
  };

  let tries = 0;
  const tick = () => {
    if (scrollToFormError() || tries++ > 20) return;
    window.setTimeout(tick, 50);
  };
  window.setTimeout(tick, 50);
});
